import loadable from '@loadable/component';

const Gallery = loadable(() => import('./Gallery'));

export default Gallery;
